module.exports = __webpack_public_path__ + "static/media/taraBaseballOne.aee1df1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taraBaseballOne.svg
// module id = 609
// module chunks = 0